const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let { default: fetch } = require('node-fetch');

async function findAvailablePets(state, controller) {let signal, response, petList;
  state.loading = true;
  signal = controller.signal;
  try {
    response = await fetch('https://petstore.swagger.io/v2/pet/findByStatus?status=available', ({ signal }));
  } catch(e) {
    console.log(e);
    state.loading = e.message;
    return 
  }
  petList = (await response.json());
  
  state.loading = false;
  state.petStore.pets = petList;
  return controller
};

function getPets(state) {let controller;
  controller = new AbortController();
  findAvailablePets(state, controller);
  return controller
};

async function deletePets(pet) {
  try {
    await fetch(`https://petstore.swagger.io/v2/pet/${pet.id}`, ({
      method: 'DELETE'
    }));
  } catch(e) {
    console.log(e);
    return 
  }
};
module.exports = { fetch, findAvailablePets, getPets, deletePets };
